import React from 'react'
import styled from '@emotion/styled'

export default ({ color, length }) => {
  return <StyledDiv color={color} length={length} />
}

const StyledDiv = styled.div`
  min-width: ${p => p.length}px;
  border-top: 4px solid ${p => p.color};
  align-self: center;
  flex-grow: 1;
`
